import { DatePicker, Input, Table } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate, numberFormat } from "../../util";



const Search = Input.Search;
const { RangePicker } = DatePicker;

class ArbitrageFlowList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flowList: [],
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getFlowList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getFlowList());
  };

  initialLoad = () => {
    this.setState({
      flowList: [],
      pagination: {
        total: 0,
        current: 1
      }}, () => {
        this.getFlowList();
      })
  }
  reload = () => {
    this.getFlowList();
  }
  getFlowList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.arbitrageFlowList,[10,pageNum],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        flowList: res.data.list,
        pagination,
      });
    });
  };
  render() {
    const { flowList } = this.state;
    const coinList = reactLocalStorage.getObject("coinList");
    const columns = [
      {
        title: "",
        dataIndex: "idx",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "이름",
        dataIndex: "userId",
        className: "support-column fs-15 lh-21",
      },
      {
        title: "코인명",
        dataIndex: "coinType",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => <div>{coinList.find((coin) => coin.coinType === data).name}</div>
      },
      {
        title: "수량",
        dataIndex: "amount",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => <div>{amountFormat(data, row.coinType) + ' ' + coinList.find((coin) => coin.coinType === row.coinType).symbol}</div>
      },
      {
        title: "생성일",
        dataIndex: "createDate",
        className: "support-column-number fs-15 lh-21",
        render: (data) => <div>{formatDate(data)}</div>
      },

    ];

    return (
      <div>
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          외부입출상세
      </div>
      <div>
        * 수량이 +인 경우는 외부에서 들어온 수익이며, -인 경우는 외부로 빠져나간 코인입니다.
      </div>
      <div className="wrapper mt-35 width-1240" />
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.amount < 0 ? "font-red" : "")}
          dataSource={flowList}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default ArbitrageFlowList;
